import { css } from '@emotion/css';
import React from 'react';
import bgPattern from 'src/assets/images/resort/bg-pattern.svg';
import { UserColor } from 'src/models/resort/UserColor';
import { UserColorHeader } from '../common/UserColorHeader';

interface PromotionPageLayoutProps {
  title: string;
  backLabel: string;
  userColor?: UserColor;
  decoId?: number;
}

export const PromotionPageLayout: React.FC<PromotionPageLayoutProps> = ({
  children,
  title,
  backLabel,
  userColor,
  decoId
}) => (
  <main
    className={css`
        width: 100%;
        height: 100%;
        overflow: hidden;
        background: url('${bgPattern}');
        isolation: isolate;
      `}
  >
    <UserColorHeader title={title} backLabel={backLabel} userColor={userColor} decoId={decoId} />
    <div
      className={css`
        height: calc(100% - 52px);
        overflow: auto;
        overflow: auto;
      `}
    >
      {children}
    </div>
  </main>
);
